import { Plugin } from './Plugin';
import { LightingPlugin } from './LightingPlugin';
import { GlobalsPlugin } from './GlobalsPlugin';
import { LightProbePlugin } from './LightProbePlugin';
import { CSMShadowsPlugin } from './CSMShadowsPlugin';
import { SpotLightShadowsPlugin } from './SpotLightShadowsPlugin';
import { DynamicEnvironmentMapPlugin } from './DynamicEnvironmentMapPlugin';
import { TAAPlugin } from './TAAPlugin';
import { SSAAPlugin } from './SSAAPlugin';
import { SMAAPlugin } from './SMAAPlugin';
import { FXAAPlugin } from './FXAAPlugin';
import { BackgroundPlugin } from './BackgroundPlugin';
import { PinsPlugin } from './PinsPlugin';
import { AmbientLight, DirectionalLight } from 'three';
// import { GTAOPass } from '../postprocessing/gtaoPass/GTAOPass';
import { APP_URL } from 'js/common/AppUrl';
import { SSAOPass } from 'three/examples/jsm/postprocessing/SSAOPass.js';
import * as dat from 'dat.gui';
import Stats from 'stats.js';

export class DebugPlugin extends Plugin{
	constructor(manager){
		super(manager);

		this.folders = new Set();


	}

	attach(){
		this.gui = new dat.GUI({
			width: 350
		});
	}

	detach(){
		this.uninstall();
		this.gui.destroy()
	}

	install(){

		this.uninstall();
		// this.debugGlobals();
		// this.debugCamera();
		this.debugPins();
		// this.debugLights();
		// this.debugLightProbe();
		// this.debugDynEnvMap();
		// this.debugCSMShadows();
		// this.debugSpotLightShadows();
		// this.debugGTAO();
		// this.debugSSAO();
		// this.debugTAA();
		// this.debugSSAA();
		// this.debugSMAA();
		// this.debugFXAA();

		// this.debugLighting();
		// this.debugBackground();
		// this.viewer.rendering.ticker.on('tick', this.render);
	}

	uninstall(){
		// this.viewer.rendering.ticker.off('tick', this.render);
		this.folders.forEach(folder => this.gui.removeFolder(folder));
		this.folders = new Set();
	}

	update(){
		this.install();
	}

	debugGlobals(){
		const dynEnvMapPlugin  = this.manager.get(DynamicEnvironmentMapPlugin);
		const plugin  = this.manager.get(GlobalsPlugin);
		const gui 	  = this.gui.addFolder('Globals');


		let envMaps 	= ['hdr-envmap.hdr', 'hdr-envmap-2.hdr', 'background-1.hdr'].map(name => [name, `${APP_URL}/assets/webgl/${name}`]);
		let backgrounds = ['background-1.hdr'].map(name => [name, `${APP_URL}/assets/webgl/${name}`]);
		this.viewer.textureLoader.add(envMaps.map(([name, path]) => path));
		this.viewer.textureLoader.add(backgrounds.map(([name, path]) => path));

		envMaps.push(["Dynamic", "dynamic"]);
		envMaps.push(["None", null]);
		backgrounds.push(["None", null]);

		const data = {
			'envMap':envMaps[0][1],
			'background':backgrounds[0][1],
			'envMapIntensity':0.5
		};

		envMaps = Object.fromEntries(envMaps);
		backgrounds = Object.fromEntries(backgrounds);


		gui.add(plugin, 'toneMapping', {
			'None': 'None',
			'Linear': 'Linear',
			'Reinhard': 'Reinhard',
			'Cineon': 'Cineon',
			'ACESFilmic': 'ACESFilmic',
			'Custom': 'Custom'
		});
		gui.add(plugin, 'toneMappingExposure', 0.01, 10, 0.01);
		gui.add(plugin, 'toneMappingWhitepoint', 0.01, 10, 0.01);
		gui.add(plugin, 'physicallyCorrectLights');

		gui.add(data, 'envMapIntensity').min(0).max(1).step(0.01).onChange((v) => {
			this.viewer.rendering.scene.traverse((obj) => {
				if(obj.isMesh && obj.material){
					obj.material.envMapIntensity = v;
				}
			});
			this.requestRender();
		});
		gui.add(data, 'envMap', envMaps).onChange(async (v) => {
			if(v){
				if(v == "dynamic"){
					dynEnvMapPlugin.render();
					plugin.envMap = dynEnvMapPlugin.texture;
				}
				else{
					await this.viewer.textureLoader.load();
					plugin.envMap = this.viewer.textureLoader.get(v)
				}
			}
			else plugin.envMap = null;
		});
		gui.add(data, 'background', backgrounds).onChange(async (v) => {
			if(v){
				await this.viewer.textureLoader.load();
				plugin.background = this.viewer.textureLoader.get(v)
			}
			else plugin.background = null;
		});

		gui.add(plugin, 'outputEncoding', {
			'LinearEncoding': 'linear',
			'sRGBEncoding': 'srgb',
			'GammaEncoding': 'gamma',
			'RGBEEncoding': 'rgbe',
			'LogLuvEncoding': 'logluv',
			'RGBM7Encoding': 'rgbm7',
			'RGBM16Encoding': 'rgbm16',
			'RGBDEncoding': 'rgbd'
		});

		gui.add(plugin, 'antialias');
		gui.add(plugin, 'usePMREM');

		this.folders.add(gui);
	}

	debugCamera(){
		const camera = this.viewer.rendering.camera
		const gui = this.gui.addFolder('Camera');

		gui.add(camera, 'fov', 10, 90, 1).onChange(this.requestRender);

		this.folders.add(gui);
	}


	debugPins(){
		const plugin = this.manager.get(PinsPlugin);
		if(plugin){
			const gui = this.gui.addFolder('Pins');

			gui.add(plugin, 'collisionEnabled').onChange(this.requestRender);
			gui.add(plugin, 'shouldTestCollisions').listen().onChange(this.requestRender);

			this.folders.add(gui);
		}
	}


	debugLights(){
		const plugin = this.manager.get(LightingPlugin);
		if(plugin.lights.size){
			const gui = this.gui.addFolder('Lights');

			plugin.lights.forEach((light, name) => {
				const f = gui.addFolder(name);
				f.add(light, 'intensity').min(0).max(2).step(0.01).onChange(this.requestRender);
				f.addThreeColor(light, 'color', () => this.requestRender);

				if(light instanceof AmbientLight){
				}
				else if(light instanceof DirectionalLight){
					f.add(light, 'castShadow').onChange(this.requestRender);
					f.add(light.position, 'x').onChange(this.requestRender);
					f.add(light.position, 'y').onChange(this.requestRender);
					f.add(light.position, 'z').onChange(this.requestRender);
					f.add(light.shadow, 'bias').min(0).max(0.1).step(0.0001).onChange(this.requestRender);
					f.add(light.shadow, 'normalBias').min(0).max(0.1).step(0.0001).onChange(this.requestRender);
					f.add(light.shadow, 'radius').min(0).max(10).step(0.1).onChange(this.requestRender);
				}
			})

			this.folders.add(gui);
		}
	}


	debugLightProbe(){
		const plugin = this.manager.get(LightProbePlugin);
		if(plugin.lightProbe){
			const gui = this.gui.addFolder('LightProbe');

			gui.add(plugin.lightProbe, 'intensity').min(0).max(1).step(0.01).onChange(this.requestRender);

			this.folders.add(gui);
		}
	}


	debugDynEnvMap(){
		const plugin = this.manager.get(DynamicEnvironmentMapPlugin);
		const gui = this.gui.addFolder('DynEnvMap');

		gui.add(plugin, 'debug').name("Show EnvMap");

		this.folders.add(gui);
	}

	// debugGTAO(){

	// 	const gtaoPass = this.viewer.gtaoPass;

	// 	if(gtaoPass){
	// 		const gui = this.gui.addFolder('GTAO');
	// 		gui.add(gtaoPass, 'enabled').onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'renderTargetScale').min(0.1).max(2).step(0.1).onChange(this.viewer.resize);
	// 		gui.add(gtaoPass, 'numSteps').min(0).max(10).step(1).onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'numDirections').min(1).max(10).step(1).onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'stepOffset').min(0).max(10).step(0.01).onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'directionOffset').min(0).max(10).step(0.01).onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'radius').min(0).max(10).step(0.01).onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'intensity').min(0).max(2).step(0.01).onChange(this.requestRender);
			
	// 		gui.add(gtaoPass, 'enableJitter').onChange(this.requestRender);	
	// 		gui.add(gtaoPass, 'rotationJitter', {
	// 			NONE: GTAOPass.NO_JITTER,
	// 			RANDOM: GTAOPass.RANDOM_JITTER,
	// 			BLUE_NOISE: GTAOPass.BLUENOISE_JITTER
	// 		}).onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'radiusJitter', {
	// 			NONE: GTAOPass.NO_JITTER,
	// 			RANDOM: GTAOPass.RANDOM_JITTER,
	// 			BLUE_NOISE: GTAOPass.BLUENOISE_JITTER
	// 		}).onChange(this.requestRender);
			
	// 		gui.add(gtaoPass, 'blurMode', {
	// 			'None': GTAOPass.NO_BLUR,
	// 			'Box': GTAOPass.BOX_BLUR,
	// 			'Cross': GTAOPass.CROSS_BLUR,
	// 			'Diag': GTAOPass.DIAGONAL_BLUR
	// 		}).onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'blurIterations').min(1).max(10).step(1).onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'blurStride').min(0).max(10).step(1).onChange(this.requestRender);
			

	// 		gui.add(gtaoPass, 'enableFalloff').onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'falloffStart').min(0).max(10).step(0.01).onChange(this.requestRender);
	// 		gui.add(gtaoPass, 'falloffEnd').min(0).max(10).step(0.01).onChange(this.requestRender);

	// 		gui.add(gtaoPass, 'ambientIntensity').min(0).max(10).step(0.01).onChange(this.requestRender);
	// 		gui.addThreeColor(gtaoPass, 'ambientColor', () => this.requestRender);

	// 		gui.add(gtaoPass, 'lightBounceIntensity').min(0).max(10).step(0.01).onChange(this.requestRender);
			
	// 		gui.add(gtaoPass.debug, 'display', {
	// 			'Default': GTAOPass.DEFAULT,
	// 			'Depth': GTAOPass.DEPTH,
	// 			'Normal': GTAOPass.NORMAL,
	// 			'AO': GTAOPass.AO_SAMPLE,
	// 			'Color': GTAOPass.COLOR_SAMPLE
	// 		}).onChange((value) => {
	// 			gtaoPass.debug.display = parseInt(value);
	// 			this.requestRender();
	// 		});
	// 		this.folders.add(gui);
	// 	}
	// }

	debugSSAO(){

		const ssaoPass = this.viewer.ssaoPass;
		if(ssaoPass){
			const gui = this.gui.addFolder('SSAO');

			gui.add(ssaoPass, 'enabled').onChange(this.requestRender);
			gui.add( ssaoPass, 'output', {
				'Default': SSAOPass.OUTPUT.Default,
				'SSAO Only': SSAOPass.OUTPUT.SSAO,
				'SSAO Only + Blur': SSAOPass.OUTPUT.Blur,
				'Beauty': SSAOPass.OUTPUT.Beauty,
				'Depth': SSAOPass.OUTPUT.Depth,
				'Normal': SSAOPass.OUTPUT.Normal
			} ).onChange(( value ) => {
				ssaoPass.output = parseInt( value );
				this.requestRender();
			} );
			gui.add( ssaoPass, 'kernelRadius' ).min( 0 ).max( 32 ).onChange(this.requestRender);
			gui.add( ssaoPass, 'minDistance' ).min( 0.001 ).max( 0.02 ).onChange(this.requestRender);
			gui.add( ssaoPass, 'maxDistance' ).min( 0.01 ).max( 0.3 ).onChange(this.requestRender);

			this.folders.add(gui);
		}

	}

	debugCSMShadows(){
		const plugin = this.manager.get(CSMShadowsPlugin);
		if(plugin && plugin.csm){

			const gui = this.gui.addFolder('CSM Shadows');

			gui.add(plugin.csm, 'fade').onChange(() => {
				plugin.csm.updateFrustums();
				this.requestRender();
			})
			gui.add(plugin.csm.lightDirection, 'x').min(-1).max(1).step(0.01).name('Light X').onChange(this.requestRender);
			gui.add(plugin.csm.lightDirection, 'y').min(-1).max(1).step(0.01).name('Light Y').onChange(this.requestRender);
			gui.add(plugin.csm.lightDirection, 'z').min(-1).max(1).step(0.01).name('Light Z').onChange(this.requestRender);
			gui.add(plugin.csm, 'lightIntensity').min(0).max(1).step(0.01).name('Light Intensity').onChange((v) => {
				plugin.csm.lights.forEach(light => light.intensity = v)
				this.requestRender();
			});
			gui.add(plugin.csm, 'lightNear').min(0).max(200).step(0.01).onChange((v) => {
				plugin.csm.lights.forEach(light => {
					light.shadow.camera.near = v;
					light.shadow.camera.updateProjectionMatrix();
				});
				this.requestRender();
			});
			gui.add(plugin.csm, 'lightFar').min(0).max(2000).step(1).onChange((v) => {
				plugin.csm.lights.forEach(light => {
					light.shadow.camera.far = v;
					light.shadow.camera.updateProjectionMatrix();
				});
				this.requestRender();
			});
			gui.add(plugin.csm, 'lightMargin').min(0).max(200).step(1).onChange(this.requestRender);

			this.folders.add(gui);
		}

	}

	debugSpotLightShadows(){
		const plugin = this.manager.get(SpotLightShadowsPlugin);
		if(plugin && plugin.light){

			const gui = this.gui.addFolder('SpotLight Shadows');

			gui.add(plugin.light.position, 'x').min(-3).max(3).step(0.01).onChange(this.requestRender);
			gui.add(plugin.light.position, 'y').min(-3).max(10).step(0.01).onChange(this.requestRender);
			gui.add(plugin.light.position, 'z').min(-3).max(3).step(0.01).onChange(this.requestRender);
			gui.add(plugin.light, 'intensity').min(0).max(2).step(0.01).onChange(this.requestRender);
			gui.add(plugin.light, 'angle').min(0).max(Math.PI).step(0.01).onChange(this.requestRender);
			gui.add(plugin.light, 'penumbra').min(0).max(1).step(0.01).onChange(this.requestRender);
			gui.add(plugin.light.shadow.camera, 'near').min(0).max(30).step(0.01).onChange((v) => {
				plugin.light.shadow.camera.near = v;
				plugin.light.shadow.camera.updateProjectionMatrix();
				this.requestRender();
			});
			gui.add(plugin.light.shadow.camera, 'far').min(0).max(30).step(0.01).onChange((v) => {
				plugin.light.shadow.camera.far = v;
				plugin.light.shadow.camera.updateProjectionMatrix();
				this.requestRender();
			});
			gui.add(plugin.light.shadow, 'bias').min(-0.2).max(0.2).step(0.0001).onChange(this.requestRender);
			gui.add(plugin.light.shadow, 'normalBias').min(-0.2).max(0.2).step(0.0001).onChange(this.requestRender);
			gui.add(plugin.light.shadow, 'radius').min(0).max(10).step(0.01).onChange(this.requestRender);

			this.folders.add(gui);
		}

	}

	debugTAA(){
		const plugin = this.manager.get(TAAPlugin);
		if(plugin){

			const gui = this.gui.addFolder('TAA');

			gui.add(plugin.taa, 'enabled').onChange(this.requestRender);
			gui.add(plugin.taa, 'unbiased').onChange(this.requestRender);
			gui.add(plugin.taa, 'accumulate').onChange(this.requestRender);
			gui.add(plugin.taa, 'sampleLevel', {
				'Level 0: 1 Sample': 0,
				'Level 1: 2 Samples': 1,
				'Level 2: 4 Samples': 2,
				'Level 3: 8 Samples': 3,
				'Level 4: 16 Samples': 4,
				'Level 5: 32 Samples': 5
			} ).onChange(this.requestRender);


			this.folders.add(gui);
		}

	}

	debugSSAA(){
		const plugin = this.manager.get(SSAAPlugin);
		if(plugin){

			const gui = this.gui.addFolder('SSAA');

			gui.add(plugin.ssaa, 'enabled').onChange(this.requestRender);
			gui.add(plugin.ssaa, 'unbiased').onChange(this.requestRender);
			gui.add(plugin.ssaa, 'sampleLevel', {
				'Level 0: 1 Sample': 0,
				'Level 1: 2 Samples': 1,
				'Level 2: 4 Samples': 2,
				'Level 3: 8 Samples': 3,
				'Level 4: 16 Samples': 4,
				'Level 5: 32 Samples': 5
			} ).onChange(this.requestRender);


			this.folders.add(gui);
		}

	}

	debugSMAA(){
		const plugin = this.manager.get(SMAAPlugin);
		if(plugin){

			const gui = this.gui.addFolder('SMAA');

			gui.add(plugin.smaa, 'enabled').onChange(this.requestRender);


			this.folders.add(gui);
		}

	}

	debugFXAA(){
		const plugin = this.manager.get(FXAAPlugin);
		if(plugin){

			const gui = this.gui.addFolder('FXAA');

			gui.add(plugin.fxaa, 'enabled').onChange(this.requestRender);


			this.folders.add(gui);
		}

	}

	debugBackground(){
		const plugin = this.manager.get(BackgroundPlugin);
		if(plugin){
			const gui = this.gui.addFolder('Background');

			gui.add(plugin, 'rotation').min(0).max(Math.PI*2).step(0.01).onChange(this.requestRender);

			this.folders.add(gui);
		}
	}

	debugLighting(){
		this.debugSimpleGlobals();
		this.debugSimpleLighting();
		this.debugSimpleSpotlight();
	}

	debugSimpleGlobals(){
		const plugin  = this.manager.get(GlobalsPlugin);
		const gui 	  = this.gui.addFolder('Globals');

		const data = {'envMapIntensity':0.5};
		gui.add(plugin, 'toneMapping', {
			'None': 'None',
			'Linear': 'Linear',
			'Reinhard': 'Reinhard',
			'Cineon': 'Cineon',
			'ACESFilmic': 'ACESFilmic',
			'Custom': 'Custom'
		});
		gui.add(plugin, 'toneMappingExposure', 0.01, 10, 0.01);
		gui.add(plugin, 'toneMappingWhitepoint', 0.01, 10, 0.01);

		gui.add(data, 'envMapIntensity').min(0).max(1).step(0.01).onChange((v) => {
			this.viewer.rendering.scene.traverse((obj) => {
				if(obj.isMesh && obj.material){
					obj.material.envMapIntensity = v;
				}
			});
			this.requestRender();
		});

		gui.add(plugin, 'outputEncoding', {
			'LinearEncoding': 'linear',
			'sRGBEncoding': 'srgb',
			'GammaEncoding': 'gamma',
			'RGBEEncoding': 'rgbe',
			'LogLuvEncoding': 'logluv',
			'RGBM7Encoding': 'rgbm7',
			'RGBM16Encoding': 'rgbm16',
			'RGBDEncoding': 'rgbd'
		});

		this.folders.add(gui);
	}
	debugSimpleLighting(){
		const plugin = this.manager.get(LightingPlugin);
		if(plugin.lights.size){
			const gui = this.gui.addFolder('Lightings');

			plugin.lights.forEach((light, name) => {
				const f = gui.addFolder(name);
				f.add(light, 'intensity').min(0).max(2).step(0.01).onChange(this.requestRender);
				f.addThreeColor(light, 'color', () => this.requestRender);

				if(light instanceof AmbientLight){
				}
				else if(light instanceof DirectionalLight){
					f.add(light.position, 'x').onChange(this.requestRender);
					f.add(light.position, 'y').onChange(this.requestRender);
					f.add(light.position, 'z').onChange(this.requestRender);
				}
			})

			this.folders.add(gui);
		}
	}

	debugSimpleSpotlight(){
		const plugin = this.manager.get(SpotLightShadowsPlugin);
		if(plugin && plugin.light){
			const gui = this.gui.addFolder('SpotLight');
			gui.add(plugin.light, 'intensity').min(0).max(3).step(0.01).onChange(this.requestRender);

			this.folders.add(gui);
		}
	}


	requestRender = () => {
		this.viewer.rendering.requestRender();
	}

	render = () => {
		this.stats.update();
	}
}


dat.GUI.prototype.addThreeColor = function(obj,varName, cb = () => {}){
    // threejs & dat.gui have color incompatible formats so we use a dummy data as target :
    var dummy={};
    // set dummy initial value :
    dummy[varName]=obj[varName].getHex(); 
    

    return this.addColor(dummy,varName).onChange((colorValue) => {
        obj[varName].set(colorValue);
        cb(colorValue);
    });
};
dat.GUI.prototype.addThreeUniformColor=function(material,uniformName,label){
    return this.addThreeColor(material.uniforms[uniformName],"value").name(label||uniformName);
};